import { createApp } from "vue";
import CatalogPrices from "./CatalogPrices.vue";

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector("#catalogPrices") !== null) {

        const catalogPrices = createApp({
            components: {CatalogPrices },
            mounted() {
                // console.log('mounted #catalogPrices')
            }
        });

        catalogPrices.mount("#catalogPrices")
    }

})